import { Autocomplete, TextField } from '@mui/material'

const CONTACTOS = [
  'Propio alumno',
  'Padre',
  'Madre',
  'Hermano',
  'Hermana',
  'Tío',
  'Tía',
  'Abuelo',
  'Abuela',
  'Pareja',
  'Familiar',
  'Amigo',
  'Amiga',
  'Otro'
]

const LeadContactoSelector = ({
  className,
  name,
  label = 'Contacto',
  value,
  onChange
}) => (
  <Autocomplete
    className={className}
    name={name}
    id={name}
    value={value}
    onChange={onChange}
    onInputChange={(event, value, reason) =>
      reason !== 'reset' && onChange(event, value)
    }
    options={CONTACTOS}
    freeSolo
    renderInput={params => (
      <TextField {...params} variant='standard' label={label} />
    )}
  />
)

export default LeadContactoSelector
